<template>
  <layout
    background="bg-gradient-light"
    class="text-gray-600 bg-chplus"
    v-statusbar:#fff
  >
    <top-small class="text-chplus-regular text-interaction-dark">
      <template v-slot:left>
        <back-button style="color: var(--interaction-dark)" />
      </template>
      <template v-slot:default>
        <slot name="navbar"></slot>
      </template>
    </top-small>
    <top-sub-b>
      <span class="text-chplus-xl">{{ title }}</span>
    </top-sub-b>
    <box-title-sub-s class="text-chplus-s" v-if="!!subtitle">
      <span class="text-color-regular">{{ subtitle }}</span>
    </box-title-sub-s>
    <content-scroll-container class="flex-grow h-full">
      <content-scroll-inner class="h-full no-scrollbar">
        <div class="h-full overflow-y-auto flow-text content lg:px-12">
          <slot name="content"></slot>
        </div>
      </content-scroll-inner>
    </content-scroll-container>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/LayoutEnvelope";
import TopSmall from "@/components/layouts/TopSmall";
import BackButton from "@/components/buttons/BackButton";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import TopSubB from "@/components/layouts/TopSubB";
import BoxTitleSubS from "@/components/layouts/BoxTitleSubS";
import StatusBarDirective from "@/directives/StatusBarDirective";

export default {
  name: "InformationPage",
  directives: {
    statusbar: StatusBarDirective
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    }
  },
  components: {
    ContentScrollInner,
    ContentScrollContainer,
    BackButton,
    TopSmall,
    Layout,
    TopSubB,
    BoxTitleSubS
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("userPath/checkPath", from.name);
    });
  }
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  scrollbar-color: rgba(0, 0, 0, 0) rgba(0, 0, 0, 0); /* Firefox, set color to invisible*/
}
</style>
